import { render, staticRenderFns } from "./AdminAccountTabData.vue?vue&type=template&id=36dafc6e&scoped=true"
import script from "./AdminAccountTabData.vue?vue&type=script&lang=js"
export * from "./AdminAccountTabData.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountTabData.vue?vue&type=style&index=0&id=36dafc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dafc6e",
  null
  
)

export default component.exports